<template>
    <v-app-bar elevation="0">
        <v-app-bar-title>
            <v-img
                class="tw-flex-grow-0"
                height="36"
                src="../assets/logo.svg"
                width="36"></v-img>
            <CategoryName
                class="tw-text-lg tw-font-bold tw-text-dark"
                :name="pageTitle" />
            <v-spacer></v-spacer>
            <v-btn
                :active="false"
                class="tw-border-gray-300 tw-text-dark"
                height="35"
                icon
                :to="{ name: 'Search' }"
                variant="outlined"
                width="35">
                <SearchIcon class="tw-h-4 tw-w-4" />
            </v-btn>
            <NotificationsModal v-if="isNotificationsActive" />
        </v-app-bar-title>
    </v-app-bar>
</template>

<script setup lang="ts">
    import SearchIcon from '@/components/icons/Search.vue';
    import useNotifications from '@/composables/useNotifications';
    import NotificationsModal from '@/views/notifications/modal.vue';

    const $route = useRoute();
    const notifications = useNotifications();

    const pageTitle = computed(() => {
        // get the i18n key from the meta title of the current route
        const titleKey = $route.meta.title as string;
        return titleKey || 'App.title';
    });

    const isNotificationsActive = ref(false);

    onMounted(async () => {
        isNotificationsActive.value = await notifications.notificationsActive();
    });
</script>

<style lang="scss">
    .v-toolbar-title__placeholder {
        @apply tw-flex tw-flex-row tw-items-center tw-gap-4;
    }

    .v-app-bar-title {
        @apply tw-mx-5;
    }
</style>
